var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPause48Line = function SvgIconPause48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 36.7h-2.6c-1.6 0-2.9-1.3-2.9-2.9V14.2c0-1.6 1.3-2.9 2.9-2.9h2.6c1.6 0 2.9 1.3 2.9 2.9v19.6c0 1.6-1.3 2.9-2.9 2.9Zm-2.1-3.4h1.6V14.7h-1.6v18.6ZM32.8 36.7h-2.6c-1.6 0-2.9-1.3-2.9-2.9V14.2c0-1.6 1.3-2.9 2.9-2.9h2.6c1.6 0 2.9 1.3 2.9 2.9v19.6c0 1.6-1.3 2.9-2.9 2.9Zm-2.1-3.4h1.6V14.7h-1.6v18.6Z",
    fill: "current"
  })));
};
export default SvgIconPause48Line;